import CommentsFinishPage from './CommentsFinishPage'

export default CommentsFinishPage
